import { API_ADDR, DEBUG, ENV, ROOT_ADDR, SESSION_EXPIRED_CODE } from '../config';
import { logout } from './lib';

export function formatParam(param, prefix=''){
    if(Array.isArray(param)){
        return formatArray(param, prefix).flat();
    }else if(typeof param === 'object'){
        return formatObject(param, prefix).flat();
    }else{
        return param;
    }
}
export function formatArray(arr, prefix){
    let output = [];
    for(let i = 0 ; i < arr.length ; i++){
        output.push(dispatch(prefix, i, arr));
    }
    return output;
}
export function formatObject(obj, prefix){
    let output = [];
    for(let p in obj){
        output.push(dispatch(prefix, p, obj));
    }
    return output;
}
export function dispatch(prefix, index, obj){
    let new_prefix = prefix === '' ? encodeURIComponent(index) : prefix + '['+ encodeURIComponent(index) +']';
    if(typeof obj[index] === 'object'){
        return formatParam(obj[index], new_prefix);
    }else{
        let v = encodeURIComponent(obj[index]);
        return new_prefix + '=' + v;
    }
}

export function http_request(path, method = 'GET', params = {}, root_path = false, is_json=true) {
    let url = root_path ? `${ROOT_ADDR}${path}` : `${API_ADDR}${path}`;
    const user_info = JSON.parse(localStorage.getItem('user_info_company') || '{}');

    switch (method) {
        case 'POST':
            var form_data = formatParam(params);
            form_data = form_data.join("&");
            break;
        case 'GET':
            if(Object.keys(params).length){
                url += '?';
                url += Object.keys(params).map(p=>`${p}=${params[p]}`).join('&');
                url = encodeURI(url);
            }
            break;
    }
    let header_config = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'application/json'
    };
    header_config.Authorization = 'Bearer ' + user_info.access_token;
    return fetch(url, {
        method,
        body: form_data,
        credentials: 'include',
        headers: new Headers(header_config)
    }).then(response => {
        if(response.status == 200){
            if(is_json) return response.json();
            return response;
        }else if((response.status + '').substring(0,2) !== '20'){
            throw new Error(response.status);
        }
    }).catch(e=>{
        logout();
    });
}

export function check_response(response, callback){
    if(!callback) callback = ()=>{};
    if(response.message == SESSION_EXPIRED_CODE){
        callback();
        return false;
    }else{
        return true;
    }
}

export function dataURItoBlob(dataURI) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
}

export default { http_request, check_response, dataURItoBlob };